import { Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { OnboardingLabelService } from './onboardingStepLabels.service';

@Injectable({
  providedIn: 'root',
})
export class PutStepService {
  constructor(
    public settings: SettingsService,
    private onboardingLabel: OnboardingLabelService
  ) {}

  async put_step(stepValue: number, id_company: any, id_simulation?: any) {
    try {
      let payload: any = {
        step: stepValue,
      };

      if (id_simulation) {
        payload['simulation_id'] = id_simulation;
      }

      const bd: any = await this.settings.get_query(
        3,
        `onboarding/guardar-paso-company/${id_company}/`,
        payload
      );
      var body_data: any = bd._body;

      const label = this.onboardingLabel.getLabel(stepValue);



      console.log(`put_step: paso: ${stepValue} y label: ${label}`);

    } catch (bd: any) {
      console.error('Error al actualizar el paso');
    }
  }
}
